<div class="row">
  <div class="col-md-5">
    <mat-card class="h-100">
      <mat-card-header>
        <mat-card-title>Return Perfomance</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <table class="table table-cim table-cim-small table-cim-padding">
          <thead>
            <tr>
              <th class="text-grey">Model</th>
              <th class="text-grey">YTD</th>
              <th class="text-grey">1 Yr</th>
              <th class="text-grey">5 Yr</th>
              <th class="text-grey">10 Yr</th>
              <th class="text-grey">15 Yr</th>
              <th class="text-grey">Since start</th>
              <th class="text-bold text-end">Div Yield</th>
            </tr>
          </thead>
          <tbody>
            @for (item of returnList; track item.index) {
              <tr>
                <td class="text-bold">{{ item.index }}</td>
                <td class="text-semi-bold">
                  {{ item.ytd | number: "1.0-2" }}%
                </td>
                <td class="text-semi-bold">
                  {{ item["1_yr"] | number: "1.0-2" }}%
                </td>
                <td class="text-semi-bold">
                  {{ item["5_yr"] | number: "1.0-2" }}%
                </td>
                <td class="text-semi-bold">
                  {{ item["10_yr"] | number: "1.0-2" }}%
                </td>
                <td class="text-semi-bold">
                  {{ item.since_2000 | number: "1.0-2" }}%
                </td>
                <td class="text-semi-bold text-end">
                  {{ item.div_yield | number: "1.0-2" }}%
                </td>
              </tr>
            }
          </tbody>
        </table>
        <p class="mt-2 mb-0 text-small">
          All return- and volatility metrics except YTD are annualized
        </p>
      </mat-card-content>
    </mat-card>
  </div>
  <div class="col-md-4">
    <mat-card class="h-100">
      <mat-card-header>
        <mat-card-title>Risk-Adjusted Outperformance</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        @if (
          index.riskAdjustedOutperformance &&
          index.riskAdjustedOutperformance.length
        ) {
          <div>
            <table class="table table-cim table-cim-small table-cim-padding">
              <thead>
                <tr>
                  <th class="text-grey">Timeframe</th>
                  <th class="text-grey text-end">Frequency</th>
                </tr>
              </thead>
              @if (!hasOutperformance) {
                <tbody>
                  @for (item of index.riskAdjustedOutperformance; track item.timeframe) {
                    <tr>
                      <td>{{ item.timeframe }}</td>
                      <td class="text-bold text-end">{{ item.frequency }}%</td>
                    </tr>
                  }
                </tbody>
              }
              @if (hasOutperformance) {
                <tbody>
                  <tr>
                    <td>Month</td>
                    <td class="text-bold text-end">
                      {{ outperformance.month | number: "1.0-1" }}%
                    </td>
                  </tr>
                  <tr>
                    <td>Quarter</td>
                    <td class="text-bold text-end">
                      {{ outperformance.quarter | number: "1.0-1" }}%
                    </td>
                  </tr>
                  <tr>
                    <td>Year</td>
                    <td class="text-bold text-end">
                      {{ outperformance.year | number: "1.0-1" }}%
                    </td>
                  </tr>
                </tbody>
              }
            </table>
          </div>
        }
      </mat-card-content>
    </mat-card>
  </div>
  <div class="col-md-3">
    <mat-card class="h-100">
      <mat-card-header>
        <mat-card-title>Benchmark Exposure</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        @if (index.benchmarkExposure) {
          <table class="table table-cim table-cim-small table-cim-padding">
            <thead>
              <tr>
                <th class="text-grey">Statistic</th>
                <th class="text-grey text-end">{{ index.name }}</th>
              </tr>
            </thead>
            @if (!hasExposure) {
              <tbody>
                @for (
                  stat of index.benchmarkExposure;
                  track stat.statistic;
                  let i = $index
                ) {
                  <tr>
                    <td>{{ stat.statistic }}</td>
                    <td class="text-end">
                      {{ stat.value }}
                      @if (stat.statistic === "Alpha") {
                        <span>%</span>
                      }
                    </td>
                  </tr>
                }
              </tbody>
            }
            @if (hasExposure) {
              <tbody>
                <tr>
                  <td>Alpha</td>
                  <td class="text-end">{{ alpha | number: "1.0-2" }}%</td>
                </tr>
                <tr>
                  <td>Beta</td>
                  <td class="text-end">{{ beta | number: "1.0-2" }}</td>
                </tr>
              </tbody>
            }
          </table>
        }
      </mat-card-content>
    </mat-card>
  </div>
</div>
